import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { IDigitalProduct } from '../../../digitalProduct/models/digitalProduct.model';
import { SubscriptionService } from '../../../subscription/services/subscription.service';
import { ToolbarComponent } from '../../../shared/components/toolbar/toolbar.component';
import { ToastService } from '../../../shared/services/toast.service';
import { ICommunity, ICommunityMember } from '../../model/community.model';
import { CommunityService } from '../../services/community.service';

@Component({
    selector: 'clp-community-details',
    styleUrls: ['./communityDetails.component.scss'],
    templateUrl: './communityDetails.component.html',
    imports: [
        ToolbarComponent,
        RouterModule,
        TranslateModule,
        ReactiveFormsModule,
        CommonModule
    ],
    providers: [
        CommunityService,
        SubscriptionService,
        ToastrService
    ]
})
export class CommunityDetailsComponent implements OnInit {
    private communityService = inject(CommunityService);
    private toastService = inject(ToastService);
    private translate = inject(TranslateService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private subscriptionService = inject(SubscriptionService);

    communityForm!: FormGroup;
    id!: string | null;
    edit = false;
    members: ICommunityMember[] = [];
    subscriptions$!: Observable<IDigitalProduct[]>;

    ngOnInit(): void {
        this.id = this.route.snapshot.paramMap.get('id');
        this.edit = !!this.id;

        this.communityForm = new FormGroup({
            id: new FormControl(''),
            name: new FormControl('', [Validators.required, Validators.maxLength(80)]),
            subscriptionId: new FormControl('')
        });
        this.subscriptions$ = this.subscriptionService.getSubscriptions();

        if (this.id) {
            this.communityService.getCommunity(this.id).subscribe((community) => {
                if (!community) {
                    return;
                }

                this.id = community.id ?? null;
                this.members = community.members ?? [];
                this.communityForm.patchValue({
                    id: this.id ?? '',
                    name: community.name ?? '',
                    subscriptionId: community.subscriptionId ?? ''
                });
            });
        }
    }

    changeCommunity(formValues: { id?: string; name?: string; subscriptionId?: string }): void {
        if (this.communityForm.invalid) {
            this.communityForm.markAllAsTouched();
            return;
        }

        const community: ICommunity = {
            id: this.id ?? undefined,
            name: formValues.name ?? '',
            subscriptionId: formValues.subscriptionId?.trim() ? formValues.subscriptionId.trim() : null,
            members: this.members
        };

        const request$: Observable<ICommunity> = this.communityService.upsertCommunity(community);
        request$.subscribe((result) => {
            if (!result) {
                return;
            }

            const message = this.edit
                ? 'community.update.successMessage'
                : 'community.create.successMessage';

            this.toastService.show(this.translate.instant(message), '');
            this.router.navigate(['listCommunities']);
        });
    }
}
